function SoftwareProjects() {
  return (
    <div style={{ 
      padding: '2rem',
      minHeight: 'calc(100vh - 80px)',
      maxWidth: '1200px',
      margin: '0 auto'
    }}>
      
      <div style={{ marginBottom: '4rem' }}>
        <h3 style={{ fontSize: '28px', marginBottom: '0.5rem' }}>Ether</h3>
        <p style={{ fontSize: '16px', marginBottom: '1rem', opacity: 0.8 }}>full-stack developer</p>
        <p style={{ fontSize: '18px', marginBottom: '1.5rem' }}>
          web app for music recommendations with real-time Spotify API integration
        </p>
        <p style={{ fontSize: '16px', marginBottom: '2rem', opacity: 0.9 }}>
          made with React, Node.js, Express, MongoDB, JWT, TailwindCSS
        </p>
        <div style={{ marginTop: '2rem' }}>
          <video
            controls
            style={{
              width: '100%',
              maxWidth: '800px',
              borderRadius: '8px'
            }}
          >
            <source src="/ether demo.mov" type="video/quicktime" />
            <source src="/ether demo.mov" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>

      <div>
        <h3 style={{ fontSize: '28px', marginBottom: '0.5rem' }}>Personal Website</h3>
        <p style={{ fontSize: '16px', marginBottom: '1rem', opacity: 0.8 }}>full stack developer</p>
        <p style={{ fontSize: '18px', marginBottom: '1.5rem' }}>
          dynamic personal portfolio website (you're here right now!)
        </p>
        <p style={{ fontSize: '16px', opacity: 0.9 }}>
          made with React, HTML/CSS, JavaScript
        </p>
      </div>
    </div>
  );
}

export default SoftwareProjects;


